import {useNew as useForm} from "lib/hooks/use-form";
import Form from "./form";

const defaults = {
  active: true,
  name: "",
  rank: 100,
  tag_id: "",
  template: "Default",
  path: ""
};

export default function New() {
  const {onChange, onSubmit, value} = useForm({defaults, path: "/admin/pages/:id", url: "/api/admin/pages"});

  return (
    <>
      <h1 className="text-center">New Page</h1>
      <Form onChange={onChange} onSubmit={onSubmit} value={value} />
    </>
  );
}
